import {
  object, string, array, boolean, date,
} from 'yup';

import {
  DEALS_STATUSES, USER_STATUSES, USER_TYPES, REALTOR_ROLES, CLIENT_ROLES, EXTERNAL_SOURCES,
} from 'resources/user/user.constants';

const userSchema = object({
  id: string(),
  created_on: date().default(() => new Date()),
  updated_on: date().required(),
  env: string().oneOf(['development', 'staging', 'production']).required(),

  is_deactivated: boolean().default(false),

  company_id: string().required(),
  auth_id: string().nullable(),
  team_id: string().nullable(),

  type: string().oneOf(Object.values(USER_TYPES)).nullable(),
  roles: array()
    .when(
      'type',
      ([type], schema) => (type === USER_TYPES.CLIENT
        ? schema.of(string().oneOf(Object.values(CLIENT_ROLES))) : schema),
    )
    .when(
      'type',
      ([type], schema) => (type === USER_TYPES.REALTOR
        ? schema.of(string().oneOf(Object.values(REALTOR_ROLES))) : schema),
    )
    .nullable(),

  avatar_url: string().nullable(),
  first_name: string().nullable(),
  last_name: string().nullable(),
  phone_number: string().nullable(),
  website: string().nullable(),
  email: string().max(64).email().default(''),

  note: string().nullable(),

  goal: string().nullable(),
  gmail_integration: boolean().default(true),

  // --> only client fields
  deals_status: string().oneOf(Object.values(DEALS_STATUSES)).nullable(),
  realtor_ids: array().of(string()).nullable(),
  status: string().oneOf(Object.values(USER_STATUSES)).nullable(),
  external_source: string().oneOf(Object.values(EXTERNAL_SOURCES)).nullable(),
  external_id: string().nullable(),
  // <-- only client fields

  type_data: object()
    .when('type', ([type], schema) => {
      if (type === USER_TYPES.REALTOR) {
        return schema.shape({
          realtor_title: string().nullable(),
          onboarding_step: string().nullable(),
          bio: string().nullable().default(''),
        });
      }

      if (type === USER_TYPES.CLIENT) {
        return schema.shape({
          is_onboarding_completed: boolean().default(false),
          referred_by: string().nullable(),
        });
      }

      return schema;
    }),
  app_state: object({
    is_email_verified: boolean().default(false),
    is_task_past_due_date_available: boolean().default(false),
    is_hide_document_modal_hidden: boolean().default(false),
    is_documents_visibility_modal_hidden: boolean().default(false),
    is_agreed_to_ai_processing: boolean().default(false),
  }),
  notification_settings: object({
    activity_updates: boolean().default(true),
    weekly_reports: boolean().default(true),
  }),
});

export default userSchema;
